import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { CompanyGroupRequest, CompanyGroupResponse } from '../models';

export enum AccountSettingsActionTypes {
  GetCompanyGroupAction = '[CompanyGroup] GetCompanyGroupAction',
  GetCompanyGroupSuccessAction = '[CompanyGroup] GetCompanyGroupSuccess',
  GetCompanyGroupErrorAction = '[CompanyGroup] GetCompanyGroupError',
  GetCompanyGroupBySubDomainAction = '[CompanyGroup] GetCompanyGroupBySubDomainAction',
  GetCompanyGroupBySubDomainSuccessAction = '[CompanyGroup] GetCompanyGroupBySubDomainSuccessAction',
  ClearStateAction = '[CompanyGroup] ClearStateAction',
}

export const getCompanyGroupAction = createAction(
  AccountSettingsActionTypes.GetCompanyGroupAction,
  props<{ CompanyGroupRequest: CompanyGroupRequest }>()
);
export const getCompanyGroupSuccessAction = createAction(
  AccountSettingsActionTypes.GetCompanyGroupSuccessAction,
  props<{ CompanyGroup: CompanyGroupResponse; redirect: boolean }>()
);
export const getCompanyGroupErrorAction = createAction(
  AccountSettingsActionTypes.GetCompanyGroupErrorAction,
  props<{ failure: AppStateFailure }>()
);
export const getCompanyGroupBySubDomainAction = createAction(
  AccountSettingsActionTypes.GetCompanyGroupBySubDomainAction,
  props<{ subdomain: string }>()
);
export const getCompanyGroupBySubDomainSuccessAction = createAction(
  AccountSettingsActionTypes.GetCompanyGroupBySubDomainSuccessAction,
  props<{ CompanyGroup: CompanyGroupResponse; redirect: boolean }>()
);

export const ClearStateAction = createAction(AccountSettingsActionTypes.ClearStateAction, props<{ actionType: string }>());
